export default {
  ApiUrl: process.env.REACT_APP_NOTIFICATIONS,
  Region: process.env.REACT_APP_REGION,
  AuthMode: 'API_KEY',
  ApiKey: process.env.REACT_APP_NOTIFICATION_KEY,
};
